import CurrentInventoryBalanceQueries from './CurrentInventoryBalanceQueries'

const stockCounterCaches = {
  stockCounterCaches: {
    ...CurrentInventoryBalanceQueries,
  }
}

export default stockCounterCaches